<template>
    <div class="date-time">
        <Popup :value="show" position="bottom" :overlay="true" :close-on-click-overlay="false" >
            <DatetimePicker
                @cancel="$emit('cancel')"
                @confirm="confirmTime"
                :value="newDateTimeVal"
                :min-date="minDate"
                :max-date="maxDate"
                :title="title"
                type="datetime"
                :filter="filterFormat"
                :formatter="formatter"
            />
        </Popup>
    </div>
</template>

<script>
    import Moment from 'moment'
    import { Popup, DatetimePicker } from 'vant';

    export default {
        name: 'DateTimeLimit',
        props: {
            show:Boolean,
            title:{
                type: String,
                default: '请选择日期时间'
            },
            dateTime: {
                type: String,
                default: ''
            },
            minDate: {
                type: Date,
            },
            maxDate: {
                type: Date,
            },
            filterFormat: {
                type: Function
            }
        },
        watch:{
            dateTime:function (newVal) {
                this.newDateTimeVal = new Date(newVal);
            },
        },
        data:function () {
            return {
                newDateTimeVal: new Date(),
            }
        },
        created(){
            let time = this.dateTime || '';
            let nowTimes;
            if(time.length < 5){
                nowTimes = new Date().getTime();
            } else {
                nowTimes = new Date(time).getTime();
            }
            let minute = Moment().minute();
            let needMinute = 10 - minute % 10;
            let allTimes = nowTimes + needMinute * 60 * 1000;
            let switchTimes = Moment(allTimes).format('YYYY-MM-DD HH:MM');
            this.newDateTimeVal = new Date(switchTimes);
        },
        methods:{
            confirmTime(val){
                this.$emit('confirmTime',Moment(val).format('YYYY-MM-DD HH:mm:ss'));
            },
            formatter(type, value) {
                if (type === 'year') {
                    return `${value}年`;
                } else if (type === 'month') {
                    return `${value}月`
                }else if (type === 'day') {
                    return `${value}日`
                }else if (type === 'hour') {
                    return `${value}时`
                }else if (type === 'minute') {
                    return `${value}分`
                }
                return value;
            },
            filterMinute(type, options) {
                // 控制时、分示例
                if (type === 'hour') {
                    return options.filter(option => +option.substring(0, 2) >= 2 && + option.substring(0, 2) <= 22)
                }
                if (type === 'minute') {
                    // 考虑最后9分钟的问题
                    let myOpt = options.filter(option => +option.substring(0, 2) % 10 === 0);
                    return myOpt.length > 0 ? myOpt : options;
                }
                return options;
            }
        },
        components:{Popup ,DatetimePicker}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
    .date-time{
        .van-picker__confirm,.van-picker__cancel{
            color: #F84025;
        }
        .van-picker__title{
            font-size: 15px;
            color: #222;
        }
    }
</style>

